// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__3jgYi","nodata":"styles_nodata__3nLMw"};